"use client";

import ReactPlayer from "react-player";
import { type ReactPlayerProps } from "react-player/types";

interface VideoProps {
  url: string;
  title?: string;
  aspectRatio?: string;
  className?: string;
}

export function Video({ url, aspectRatio = "16 / 9", className = "" }: VideoProps) {
  if (!url) {
    return (
      <div
        className={`flex items-center justify-center rounded-lg bg-slate-100 ${className}`}
        style={{ aspectRatio }}
      >
        <p className="text-sm text-slate-500">No video URL provided</p>
      </div>
    );
  }

  if (ReactPlayer.canPlay && !ReactPlayer.canPlay(url)) {
    return (
      <div
        className={`flex items-center justify-center rounded-lg bg-slate-100 ${className}`}
        style={{ aspectRatio }}
      >
        <p className="text-sm text-slate-500">Unsupported video URL format</p>
      </div>
    );
  }

  // Use the responsive player approach recommended in react-player docs
  // See: https://github.com/cookpete/react-player#responsive-player
  const playerProps: ReactPlayerProps = {
    src: url,
    width: "100%",
    height: "auto",
    controls: true,
    style: {
      aspectRatio: aspectRatio.replace(/\s+/g, ""), // Remove spaces from "16 / 9" -> "16/9"
    },
    config: {
      youtube: {
        rel: 0, // Don't show related videos
        modestbranding: 1, // Minimal YouTube branding
        playsinline: 1, // Play inline on mobile
      },
      vimeo: {
        title: false,
        byline: false,
        portrait: false,
      },
    } as ReactPlayerProps["config"],
  };

  return (
    <div className={`w-full overflow-hidden rounded-lg bg-black ${className}`}>
      <ReactPlayer {...playerProps} />
    </div>
  );
}
